import MutualFundBanner from './MutualFundBanner';    
import MutualFundsSection  from './MutualFundsSection';

function MutualFund() {
  return (
    <div>
    <MutualFundBanner/>
    <MutualFundsSection />
    </div>
  );
}

export default MutualFund;